<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useVModel } from '@vueuse/core';
import { useForwardExpose } from 'reka-ui';
import { cn } from '@/lib/utils';
import { inputVariants, type InputVariants } from '.';

const props = defineProps<{
    defaultValue?: string | number;
    modelValue?: string | number;
    class?: HTMLAttributes['class'];
    size?: InputVariants['size'];
}>();

const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
});

const { forwardRef } = useForwardExpose();
</script>

<template>
    <input
        v-model="modelValue"
        data-slot="input"
        :ref="forwardRef"
        :class="cn(inputVariants({ size }), props.class)"
    />
</template>
